import { cn } from "@/lib/utils"

export type UserAvatarSize = "xs" | "sm" | "md"

const SIZE_CLASSES: Record<UserAvatarSize, string> = {
  xs: "w-5 h-5 text-[8px]",
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm"
}

interface UserAvatarProps {
  name?: string | null
  imageUrl?: string | null
  size?: UserAvatarSize
  className?: string
}

export default function UserAvatar({
  name,
  imageUrl,
  size = "sm",
  className
}: UserAvatarProps) {
  const initial = name?.trim().charAt(0)?.toUpperCase() ?? "?"
  const sizeClass = SIZE_CLASSES[size]

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name ? `${name} avatar` : "Avatar"}
        className={cn("rounded-full object-cover", sizeClass, className)}
      />
    )
  }

  return (
    <div
      className={cn(
        "rounded-full bg-gray-200 text-gray-600 flex items-center justify-center font-semibold",
        sizeClass,
        className
      )}
    >
      {initial}
    </div>
  )
}
